import { get, dispatch } from 'vuex-pathify';

export default {
  computed: {
    currentProjectId: get('layers/project.id'),
    currentDatasourceName() {
      return this.$store.get('layers/layers')[+this.$route.params.lid]?.data_source_name;
    },
    currentFeatureId() {
      return +this.$route.params.fid;
    },
    /**
     * @type 'Feature' | 'Project'
     */
    sketchesContext() {
      return this.target === '.feature-map-extended' ? 'Feature' : 'Project';
    },
    contextSendingData() {
      switch (this.sketchesContext) {
        case 'Feature':
          return {
            datasource: this.currentDatasourceName,
            featureId: this.currentFeatureId,
          };
        case 'Project':
          return {
            projectId: this.currentProjectId,
          };
        default:
          throw new Error(`Context "${this.sketchesContext}" not supported`);
      }
    },
  },
  methods: {
    /** Get sketches */
    async getContextSketches() {
      return await dispatch(`sketch/get${this.sketchesContext}Sketches`, this.contextSendingData);
    },

    /** Create sketch */
    async createContextSketch(body) {
      return await dispatch(`sketch/create${this.sketchesContext}Sketch`, {
        ...this.contextSendingData,
        body,
      });
    },

    /** Delete sketch */
    async deleteContextSketch(sketches) {
      return await dispatch(`sketch/remove${this.sketchesContext}Sketch`, {
        ...this.contextSendingData,
        sketches,
      });
    },

    /** Toggling visibility */
    setStorageVisibilityPerProjectContext() {
      const projectsWithHiddenSketches = JSON.parse(localStorage.getItem('sketches-hidden-projects') ?? '[]');
      if (this.visible) {
        const updatedProjects = projectsWithHiddenSketches.filter(projectId => projectId !== this.currentProjectId);
        if (!updatedProjects.length) localStorage.removeItem('sketches-hidden-projects');
        else localStorage.setItem('sketches-hidden-projects', JSON.stringify(updatedProjects));
      } else {
        localStorage.setItem(
          'sketches-hidden-projects',
          JSON.stringify([...projectsWithHiddenSketches, this.currentProjectId])
        );
      }
    },
    setStorageVisibilityPerFeatureContext() {
      let featuresWithHiddenSketches = JSON.parse(localStorage.getItem('sketches-hidden-features') ?? '{}');
      if (this.visible) {
        const updatedFeatures = (featuresWithHiddenSketches[this.currentDatasourceName] ?? []).filter(
          featureId => featureId !== this.currentFeatureId
        );
        if (updatedFeatures.length) featuresWithHiddenSketches[this.currentDatasourceName] = updatedFeatures;
        else delete featuresWithHiddenSketches[this.currentDatasourceName];
      } else {
        featuresWithHiddenSketches[this.currentDatasourceName] = [
          ...(featuresWithHiddenSketches[this.currentDatasourceName] ?? []),
          this.currentFeatureId,
        ];
      }
      localStorage.setItem('sketches-hidden-features', JSON.stringify(featuresWithHiddenSketches));
    },
    setStoreVisibilityPerContext() {
      switch (this.sketchesContext) {
        case 'Feature':
          return this.setStorageVisibilityPerFeatureContext();
        case 'Project':
          return this.setStorageVisibilityPerProjectContext();
        default:
          throw new Error(`Context "${this.sketchesContext}" not supported`);
      }
    },

    /** Initial visibility */
    areSketchesVisiblePerProjectContext() {
      const projectsWithHiddenSketches = JSON.parse(localStorage.getItem('sketches-hidden-projects') ?? '[]');
      return !projectsWithHiddenSketches.includes(this.currentProjectId);
    },
    areSketchesVisiblePerFeatureContext() {
      const featuresWithHiddenSketches = JSON.parse(localStorage.getItem('sketches-hidden-features') ?? '{}');
      return !(featuresWithHiddenSketches[this.currentDatasourceName] ?? []).includes(this.currentFeatureId);
    },
    areSketchesVisiblePerContext() {
      switch (this.sketchesContext) {
        case 'Feature':
          return this.areSketchesVisiblePerFeatureContext();
        case 'Project':
          return this.areSketchesVisiblePerProjectContext();
        default:
          throw new Error(`Context "${this.sketchesContext}" not supported`);
      }
    },
  },
};
